import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Gender } from "api";
import { FormDate, FormSelect, FormTextField, HeaderDivider } from "components";
import { Control } from "react-hook-form";
import { CandidateDetailsFormData } from "../validation";

export const PersonalDetails = ({
  control,
}: {
  control: Control<CandidateDetailsFormData>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider text={t("details.personalInfoTitle")} sx={{ mb: 3 }} />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="firstName"
            label={t("details.firstName.label")}
            placeholder={t("details.firstName.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="middleName"
            label={t("details.secondName.label")}
            placeholder={t("details.secondName.placeholder")}
            control={control}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormTextField
            name="lastName"
            label={t("details.lastName.label")}
            placeholder={t("details.lastName.placeholder")}
            control={control}
            required
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <FormSelect
            name="gender"
            label={t("details.gender.label")}
            placeholder={t("details.gender.placeholder")}
            control={control}
            options={[
              { label: t("details.gender.male"), value: Gender.Male },
              { label: t("details.gender.female"), value: Gender.Female },
            ]}
            required
          />
        </Grid>
        <Grid size={12}>
          <FormDate
            name={"dateOfBirth"}
            label={t("details.dateOfBirth.label")}
            control={control}
            required
          />
        </Grid>
      </Grid>
    </>
  );
};
